import { useMemo } from "react";
import { Profile } from "@/hooks/profile/types";
import { UserFiltersState } from "@/components/admin/users/UserFilters";
import { PaymentStatus } from "./useUserPayments";

export const useFilteredUsers = (
  users: Profile[] | null,
  filters: UserFiltersState,
  paymentStatusMap: Map<string, PaymentStatus>
) => {
  return useMemo(() => {
    if (!users) return [];

    return users.filter((user) => {
      // Filtro de búsqueda por texto
      if (filters.search) {
        const searchLower = filters.search.toLowerCase();
        const matchesSearch =
          user.first_name?.toLowerCase().includes(searchLower) ||
          user.last_name?.toLowerCase().includes(searchLower) ||
          user.username?.toLowerCase().includes(searchLower);

        if (!matchesSearch) return false;
      }

      // Filtro por rol
      if (filters.role !== "all" && user.role !== filters.role) {
        return false;
      }

      // Filtro por estado de cuenta
      if (filters.status !== "all") {
        const isActive = !user.banned;
        if (
          (filters.status === "active" && !isActive) ||
          (filters.status === "banned" && isActive)
        ) {
          return false;
        }
      }

      // Filtro por estado de cuota
      if (filters.paymentStatus !== "all") {
        const userPaymentStatus = paymentStatusMap.get(user.id) || "noPayments";
        if (userPaymentStatus !== filters.paymentStatus) {
          return false;
        }
      }

      return true;
    });
  }, [users, filters, paymentStatusMap]);
};
